module.exports = __webpack_public_path__ + "img/vue1-renfort_gris.e8a2835b.png";